import React from 'react';

const renderInputField = ({
    input, placeholder, type, meta: { touched, error },
}) => (
        <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
            <input {...input} placeholder={placeholder} type={type} />
            {touched && error && <span className="form__form-group-error">{error}</span>}
        </div>
    );

export default renderInputField;